import { PrebookHotelSummaryModel } from '@/__generated';
import FormItem from '@/components/Form/FormItem';
import { sumBy } from 'lodash';
import React from 'react';
import { UseFormRegister, FieldErrors, Control } from 'react-hook-form';

type Props = {
  bookingSummary: PrebookHotelSummaryModel;
  register: UseFormRegister<any>;
};

export default function SpecialRequests({ register, bookingSummary }: Props) {
  const rooms = React.useMemo(() => {
    return bookingSummary.selectedHotel?.rooms || [];
  }, [bookingSummary]);
  const displayNoSmokingRequest = React.useMemo(() => {
    return rooms.some(x => x.supplier === 'NTA' || x.smokingRoom);
  }, [rooms]);
  const totalRooms = React.useMemo(() => {
    return sumBy(rooms, x => x.noOfRooms || 0);
  }, [rooms]);
  return (
    <div className="row x-gap-10 y-gap-20 mt-20">
      <div className="col-12  ">
        <div className="d-flex align-items-center">
          <div className="fw-bold text-18 text-blue-1  rounded-2 pr-10 text-uppercase">Special Requests</div>
          <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
        </div>
      </div>

      <div className="col-md-12 col-xs-12 y-gap-4">
        {displayNoSmokingRequest ? (
          <div className="d-flex align-items-center px-10 py-10 x-gap-4 mb-10" style={{ backgroundColor: '#fff9dc', borderRadius: 10 }}>
            <img style={{ height: 50 }} src={require('@/assets/icons/hotel/no-smoking-svgrepo-com.png')} />
            <div className="flex-1">
              <div className="form-checkbox d-flex items-center mr-20 ml-10">
                <input type="checkbox" />
                <input {...register('nonSmokingRoom')} type="checkbox" />

                <div className="form-checkbox__mark">
                  <div className="form-checkbox__icon icon-check"></div>
                </div>
                <div className="  ml-10">If you need no-smoking room, please check here</div>
              </div>
              <div className=" ml-10">We will inform the hotel but it is not guaranteed.</div>
            </div>
          </div>
        ) : null}

        <div className="d-flex align-items-center px-10 py-10 x-gap-4 mb-10" style={{ backgroundColor: '#ffe7ff', borderRadius: 10 }}>
          <img style={{ height: 50 }} src={require('@/assets/icons/hotel/love-hotel-svgrepo-com.png')} />
          <div className="flex-1">
            <div className="form-checkbox d-flex items-center mr-20 ml-10">
              <input type="checkbox" />
              <input {...register('honeymooners')} type="checkbox" />

              <div className="form-checkbox__mark">
                <div className="form-checkbox__icon icon-check"></div>
              </div>
              <div className="  ml-10">Honeymooners</div>
            </div>
            <div className=" ml-10">Please check here if the guest are Honeymooners.</div>
          </div>
        </div>
        {totalRooms > 1 ? (
          <div className="d-flex align-items-center px-10 py-10 x-gap-4 mb-10" style={{ backgroundColor: '#e4f0fd', borderRadius: 10 }}>
            <img style={{ height: 50 }} src={require('@/assets/icons/hotel/hotel-lift-svgrepo-com.png')} />
            <div className="flex-1">
              <div className="form-checkbox d-flex items-center mr-20 ml-10">
                <input type="checkbox" />
                <input {...register('roomsCloseToEachOther')} type="checkbox" />

                <div className="form-checkbox__mark">
                  <div className="form-checkbox__icon icon-check"></div>
                </div>
                <div className="  ml-10">Rooms close to each other</div>
              </div>
              <div className=" ml-10">We will inform the hotel but it is not guaranteed.</div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
